// Basic error tracking utility
export const initErrorTracking = () => {
  window.addEventListener('error', (event) => {
    console.error('[Error Tracking]', {
      message: event.message,
      filename: event.filename,
      lineno: event.lineno,
      colno: event.colno,
      error: event.error
    });
    
    // You can send this to your error tracking service
    // For now, we'll just log it
    return false;
  });

  window.addEventListener('unhandledrejection', (event) => {
    console.error('[Promise Error]', {
      message: event.reason
    });
    return false;
  });
};